<template>
  <div>
    <vx-card>
      <p class="mb-5">
        From the front covers of magazines to interviews with your favourite podcasters, people look
        to entrepreneurs for their ingenuity, their can-do attitude, and their potential to shape
        their societies around them. Entrepreneurs such as Bill Gates, Henry Ford, Walt Disney and
        John D. Rockefeller have become household names due to their great successes in the business
        world.
      </p>
      <p class="mb-5">
        But what actually is an entrepreneur? And what characteristics or skills do you need to
        become a successful entrepreneur?
      </p>
      <p class="mb-5">
        At its simplest, an entrepreneur is someone who establishes a new business with the intent
        of growing it quickly (also known as ‘scaling’) and making a profit. This is typically done
        by inventing or identifying a new product, service or technology and building a business
        around it.
      </p>
      <p>
        Entrepreneurs are optimistic, think strategically, are great leaders, and are able to adapt
        to changing circumstances.
      </p>
    </vx-card>
    <vx-card class="mt-base mb-5">
      <h4 class="mb-5">Let’s start your virtual job experience in Entrepreneurship</h4>
      <p class="mb-5">
        From the front covers of magazines to interviews with your favourite podcasters, people look
        to entrepreneurs for their ingenuity, their can-do attitude, and their potential to shape
        their societies around them. Entrepreneurs such as Bill Gates, Henry Ford, Walt Disney and
        John D. Rockefeller have become household names due to their great successes in the business
        world.
      </p>
      <p class="mb-5">
        But what actually is an entrepreneur? And what characteristics or skills do you need to
        become a successful entrepreneur?
      </p>
      <p class="mb-5">
        At its simplest, an entrepreneur is someone who establishes a new business with the intent
        of growing it quickly (also known as ‘scaling’) and making a profit. This is typically done
        by inventing or identifying a new product, service or technology and building a business
        around it.
      </p>
      <p class="mb-5">
        Entrepreneurs are optimistic, think strategically, are great leaders, and are able to adapt
        to changing circumstances.
      </p>
    </vx-card>
    <vx-card>
      <h4 class="mb-5">What are the different types of entrepreneurs?</h4>
      <h5 class="mb-5">Small businesses</h5>
      <p class="mb-5">
        Small business entrepreneurs still aim to grow and create a sustaining, thriving business,
        but choose to keep their business at a fairly small size. Business such as your favourite
        non-chain restaurant, your neighbourhood newsagents or perhaps even a small group of people
        selling handicrafts on Etsy are all examples of small business entrepreneurship.
      </p>
      <p class="mb-5">
        Typically small businesses may gain a business loan to help grow or start their own
        business, but do not require large amounts of investment capital (money given in exchange
        for partial ownership of the business) compared to the large business entrepreneurs or
        start-up entrepreneurs.
      </p>
      <h5 class="mb-5">Large Business</h5>
      <p class="mb-5">
        Large business entrepreneurs is a term that can be used to describe two different types of
        entrepreneur.
      </p>
      <p class="mb-5">
        The first is an entrepreneur who builds a company with the intention to make it a scalable,
        large business. Unlike the small business entrepreneur, they aim to have several locations
        with hundreds of employees. Typically businesses like this will use a combination of their
        own money, bank business loans and investors to give them the funds they need to build their
        business.
      </p>
      <p class="mb-5">
        The other kind of large business entrepreneur works within an existing large business to
        explore a new market or opportunity. These entrepreneurs leverage the resources provided by
        the company to venture into unexploited opportunities. Compared to entrepreneurs who are in
        top leadership positions in their companies, these entrepreneurs usually have higher-ups to
        both answer to, and get advice from.
      </p>
      <h5 class="mb-5">Start-Up</h5>
      <p class="mb-5">
        There are many similarities between small businesses and start-ups. Both mainly concern
        themselves with the early stages of creating a business, but approach the challenge with
        different methods and philosophies.
      </p>
      <p class="mb-5">
        Start-ups are structured to encourage fast-growth and flexibility. They will typically spend
        most of their energy looking for a problem or opportunity in the market, and then developing
        a novel solution, thereby ‘disrupting’ the industry.
      </p>
      <p class="mb-5">
        Compared to small businesses, start-ups look for rapid growth, looking for investors or
        venture capitalists to give them the financial backing they need to bring their idea to
        life.
      </p>
      <p class="mb-5">
        Often a measure of success for a start up will be an IPO or Initial Product Offering, which
        is where the company’s ownership is divided into shares and made available for the public to
        invest in.
      </p>
      <h5 class="mb-5">Social Entrepreneurship</h5>
      <p class="mb-5">
        Recently there has been a strong focus on businesses that are not only successful and
        profitable, but also are seen to provide an additional societal good. Social entrepreneurs
        seek to create these businesses, which may either deliver a product that is seen as being
        beneficial to a community in need, or diverts their profits in part or in whole to a
        charitable cause.
      </p>
      <p class="mb-5">These organisations are sometimes called social enterprises.</p>
    </vx-card>
    <vx-card>
      <h4 class="mb-5">What tasks and responsibilities do entrepreneurs have?</h4>
      <p class="mb-5">
        What entrepreneurs will do depends on the size and stage of the business. At the early
        stages, they may be involved in all aspects of the business, but as the business scales they
        may only concern themselves with one aspect, such as product, strategy or marketing.
      </p>
      <p class="mb-5">Responsibilities may include:</p>

      <ul class="default-list">
        <li>Ideating, prototyping or creating a product or service</li>
        <li>Developing marketing strategies to help sell the product</li>
        <li>Creating proposals and presentations to attract potential investors or buyers</li>
        <li>
          Undertaking market research to identify new opportunities or evolving market conditions
        </li>
      </ul>

      <h4 class="mb-5">What do you need to become an entrepreneur?</h4>
      <p class="mb-5">
        An entrepreneur is a unique role because it doesn’t necessarily need a university degree or
        certification to become one. Famously, several entrepreneurs dropped out of college or
        university to pursue their business ideas.
      </p>
      <p class="mb-5">
        However, being an entrepreneur is more than just having a good idea - you must be able to
        have an understanding of what it is you’re trying to produce, as well as how to build a
        business around it.
      </p>
      <p class="mb-5">
        For this reason, you could choose to study or gain experience in the creation or delivery of
        the good or service you plan on building the service around (the ‘product’ side).
      </p>
      <p class="mb-5">
        These qualifications could come from just about any discipline or area of study - the
        important aspect is to gain a level of expertise that will allow you to identify
        opportunities to create a business that will fulfill an unmet need in the marketplace.
      </p>
      <p class="mb-5">
        Alternatively, you could get a qualification to learn about aspects such as management,
        marketing, sales and logistics.
      </p>
      <p class="mb-5">Popular study options include:</p>
      <p class="mb-5">Bachelor’s Degrees or higher in:</p>

      <ul class="default-list">
        <li>Marketing</li>
        <li>Finance</li>
        <li>Business (Entrepreneurship)</li>
        <li>Economics</li>
        <li>Statistics</li>
        <li>Communications</li>
        <li>Management</li>
      </ul>

      <p class="mb-5">
        Another option is a <b>Masters of Business Administration</b>, or an MBA for short. An MBA
        covers many of the above topics. Because it is a Masters’ degree, you may need an
        undergraduate degree, or significant experience that will allow you to do a Graduate
        Certificate of Business before you enrol into an MBA program.
      </p>
    </vx-card>
    <vx-card>
      <h4 class="mb-5">Highlights of Becoming an Entrepreneur</h4>

      <p class="mb-5 text-bold">1. You Get To Be Your Own Boss</p>
      <p class="mb-5">
        This is probably the primary appeal for entrepreneurs. Starting businesses can be a risky
        undertaking, but the reward can be a sense of independence and ownership over the creative
        and strategic direction of the business.
      </p>
      <p class="mb-5 text-bold">2. You’re in a constant state of learning and innovation</p>
      <p class="mb-5">
        Entrepreneurs love to learn and do research. Whether it’s gathering information on the
        current state of the market, learning innovative approaches to product development or
        organisational structure, or simply learning how to improve their product or service,
        entrepreneurs are constantly picking up new skills.
      </p>
      <p class="mb-5 text-bold">3. Entrepreneurs Get Experience Fast</p>
      <p class="mb-5">
        It’s highly unlikely that an entrepreneur will create a successful business on their first
        go - but through trying, failing, reflecting and improving, entrepreneurs get a lot of
        experience in valuable skills such as risk management, innovation and strategy that
        non-entrepreneurs are unlikely to experience unless they become high level employees at
        their workplaces.
      </p>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: require('@/assets/images/experiences/experience-one.png'),
      cover_img: require('@/assets/images/other/cover.jpg'),
      popupActive: false,
      showVideoPopup: false,
    };
  },
  provide: function () {
    return {
      openPopup: this.openPopup,
      closePopup: this.closePopup,
    };
  },
  methods: {
    openPopup() {
      this.showVideoPopup = true;
    },
    closePopup() {
      this.showVideoPopup = false;
    },
  },
};
</script>
